import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const moveInForm: Form<Client> = {
  key: 'moveInData',
  title: 'Einzug',
  fields: [
    {
      key: 'isRoomPrepared',
      label: 'Zimmer vorbereitet',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'isWasteManagementExplained',
      label: 'Müllordnung erklärt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'isOperatingInstructionProvided',
      label: 'Bedienungsanweisung gegeben',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'isFireSafetyTrainingProvided',
      label: 'Brandschutzunterweisung erfolgt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'isHandoverReportPrepared',
      label: 'Übergabeprotokoll erstellt',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'isCooperationAgreementSigned',
      label: 'Kooperationsvertrag übergeben',
      fieldTypes: 'checkbox',
      xsWidth: 12,
    },
    {
      key: 'moveInNotice',
      label: 'Notiz',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default moveInForm;
